export const timeToMillis = time => {
  if (!time) return 0
  if (typeof time === 'number') return time
  return Number(time.split(':')[0]) * 3600000 + Number(time.split(':')[1]) * 60000 + Number(time.split(':')[2]) * 1000
}
